import { useCallback, useEffect, useState } from "react";
import { Gate } from "../models/Gate";
import PlotAPI from "../plotAPI";

interface useGatesProps {
    projects: any[];
    projectInfo: (projectId: string | number) => any | null;
}

const useGates = ({ projects, projectInfo }: useGatesProps) => {
    const [gatesByProject, setGatesByProject] = useState<{ unique_token: string; gates: Gate[] }[]>([]);

    const refreshGatesByProject = useCallback(() => {
        return Promise.all(
            projects.map((project) =>
                PlotAPI.getProjectGates(
                    project.claimed_by_team_subdomain || "projects",
                    project.unique_token,
                    project.timezone
                ).then((gates) => {
                    return {
                        unique_token: project.unique_token,
                        gates,
                    };
                })
            )
        ).then((gates) => {
            setGatesByProject(gates);
        });
    }, [projects]);

    useEffect(() => {
        refreshGatesByProject();
    }, [projects, refreshGatesByProject]);

    const gatesForProject = (projectId: string | number): Gate[] => {
        const projectToken = projectInfo(projectId)?.unique_token;

        return gatesByProject.find((project) => project.unique_token === projectToken)?.gates || [];
    };

    return {
        gatesByProject,
        gatesForProject,
        refreshGatesByProject,
    };
};

export default useGates;
